import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useLocation } from 'react-router';
import { User as UserIcon } from '@linktivity/link-icons';
import { Dropdown } from '@linktivity/link-ui';
import { useHeaderContext } from './context';
import { UserMenuItem } from './header.types';
import styles from './header.module.css';

const User = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(false);
  const { logout, isPasswordAuth } = useHeaderContext();

  const userMenuItems: UserMenuItem[] = useMemo(
    () => [
      {
        label: t('views.booking.title'),
        to: 'booking'
      },
      {
        label: t('share.profile.title'),
        to: 'profile'
      },
      ...(isPasswordAuth
        ? [
            {
              label: t('share.password.changePassword'),
              to: 'change-password'
            }
          ]
        : []),
      {
        label: t('share.common.logout'),
        onClick: async () => {
          await logout();
          const { pathname, search, hash } = location;
          const fullPath = `${pathname}${search}${hash}`;
          navigate('login', {
            state: { from: { pathname: fullPath } },
            replace: true
          });
        }
      }
    ],
    [logout, location, navigate, t, isPasswordAuth]
  );

  const userButton = useMemo(
    () => (
      <button
        className={styles.navButton}
        type="button"
        onClick={() => setOpenMenu(visible => !visible)}
      >
        <UserIcon className={styles.navIcon} />
        <span className={styles.text}>{t('share.common.myPage')}</span>
      </button>
    ),
    [t]
  );

  return (
    <Dropdown
      target={userButton}
      visible={openMenu}
      sameWidth={false}
      onClose={() => setOpenMenu(false)}
    >
      <Dropdown.Menu className={styles.dropdownMenu}>
        {userMenuItems.map(({ label, to, onClick }) => (
          <Dropdown.Item key={label}>
            {to ? (
              <Link className={styles.dropdownButton} to={to}>
                {label}
              </Link>
            ) : (
              <button className={styles.dropdownButton} onClick={onClick}>
                {label}
              </button>
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default User;
